import { AnalyticsEventName } from "../analytics/ProductAnalytics";

type EventName = AnalyticsEventName;

export class ProductEvent extends CustomEvent<
  Record<string, string | number | boolean>
> {
  _productEventType: EventName;
  constructor(
    type: EventName,
    detail?: Record<string, string | number | boolean>,
  ) {
    super(type, { detail });
    this._productEventType = type;
  }
}

export class ProductEventTarget extends EventTarget {
  addEventListener(
    type: EventName,
    callback: EventListenerOrEventListenerObject,
  ): void {
    super.addEventListener(type, callback);
  }
  removeEventListener(
    type: EventName,
    callback: EventListenerOrEventListenerObject,
  ): void {
    super.removeEventListener(type, callback);
  }
  dispatchEvent(event: ProductEvent): boolean {
    return super.dispatchEvent(event);
  }
}
